// src/Splash.js
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import dsClosed from "./assets/ds-closed.png";
import dsOpenPng from "./assets/ds-open.png";
import screenGif from "./assets/screen.gif";
import lightPng from "./assets/light.png";
import enterGif from "./assets/enter.gif"; // ← add this
import "./splash.css";

export default function Splash() {
  const navigate = useNavigate();

  const [state, setState] = useState("closed"); // "closed" | "openStill" | "openGif"
  const [gifKey, setGifKey] = useState(0);
  const [overScreen, setOverScreen] = useState(false);
  const [nat, setNat] = useState({ w: 0, h: 0 });
  const wrapRef = useRef(null);

  useEffect(() => {
    [dsClosed, dsOpenPng, screenGif, lightPng, enterGif].forEach((src) => {
      const i = new Image();
      i.src = src;
    });
  }, []);

  useEffect(() => {
    const img = new Image();
    img.src = dsOpenPng;
    img.onload = () => setNat({ w: img.naturalWidth, h: img.naturalHeight });
  }, []);

  useEffect(() => {
    const onDocDown = (e) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target)) {
        setState("closed");
        setOverScreen(false);
      }
    };
    document.addEventListener("mousedown", onDocDown);
    document.addEventListener("touchstart", onDocDown, { passive: true });
    return () => {
      document.removeEventListener("mousedown", onDocDown);
      document.removeEventListener("touchstart", onDocDown);
    };
  }, []);

  const onMouseEnterDS = () => {
    if (state === "closed") setState("openStill");
  };
  const onMouseLeaveDS = () => {
    if (state === "openStill") setState("closed");
    setOverScreen(false);
  };
  const onClickDS = () => {
    if (state !== "openGif") {
      setState("openGif");
      setGifKey((k) => k + 1);
    }
  };

  const onHotEnter = () => setOverScreen(true);
  const onHotLeave = () => setOverScreen(false);
  const onHotClick = () => navigate("/home");

  const baseSrc = state === "closed" ? dsClosed : dsOpenPng;
  const wrapStyle = nat.w && nat.h ? { aspectRatio: `${nat.w} / ${nat.h}` } : undefined;

  return (
    <div className="splash-overlay" role="dialog" aria-modal="true" aria-label="Intro">
      <div
        ref={wrapRef}
        className={`ds-wrap ${state}`}
        style={wrapStyle}
        onMouseEnter={onMouseEnterDS}
        onMouseLeave={onMouseLeaveDS}
        onClick={onClickDS}
        onTouchStart={() => {
          if (state === "closed") setState("openStill");
        }}
      >
        {/* ENTER GIF: only show when DS is closed */}
        {state === "closed" && (
          <img
            src={enterGif}
            alt="Open me"
            className="enter-gif"
            draggable="false"
          />
        )}

        <img src={baseSrc} alt="DS" className="ds-img" draggable="false" />

        {state === "openGif" && (
          <>
            <img
              src={`${screenGif}?k=${gifKey}`}
              alt=""
              className="cover-all ds-screen-gif"
              draggable="false"
            />
            <div
              className="cover-all ds-screen-hotspot"
              onMouseEnter={onHotEnter}
              onMouseLeave={onHotLeave}
              onClick={onHotClick}
              role="button"
              tabIndex={0}
              aria-label="Enter hotspot"
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") && onHotClick()
              }
            />
            {overScreen && (
              <img
                src={lightPng}
                alt=""
                className="cover-all ds-light-img"
                draggable="false"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}
